import React, { useState, useEffect } from 'react';
import './SimplyPage.css';

const SimplyPage = ({ darkMode }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [showForm, setShowForm] = useState(false);
  
  // Frases motivacionales para mostrar aleatoriamente
  const motivationalPhrases = [
    "Gracias por cuidar con corazón cada día.",
    "Hoy también haces que el mundo sea un lugar más humano.",
    "Pequeños cuidados, grandes diferencias.",
    "Cada día que empiezas aquí, alguien empieza a sentirse mejor.",
    "Tu esfuerzo diario construye bienestar en los demás.",
    "Cada acción tuya mejora la vida de alguien más.",
    "Gracias por estar, por cuidar y por seguir sumando humanidad.",
    "Hoy tus manos y tu tiempo volverán a marcar la diferencia.",
    "Porque cuando cuidas, el mundo se vuelve un poco más amable.",
    "Tu presencia es la parte más importante del cuidado.",
    "Tu trabajo tiene más impacto del que imaginas.",
    "Lo que haces cada día deja una huella silenciosa pero profunda.",
    "Cuidar también es una forma de dejar huella.",
    "Tu vocación da sentido a cada día de quienes te rodean.",
    "A veces el mejor remedio es tu compañía.",
    "El cuidado empieza con una sonrisa, y tú traes muchas.",
    "Tu labor no se mide en horas, sino en bienestar.",
    "El valor de lo que haces no cabe en una pantalla.",
    "Gracias por ser parte del cambio que se nota, aunque a veces no se vea.",
    "Cada persona a la que ayudas deja un poco de su historia en ti."
  ];

  // Seleccionar una frase aleatoria al cargar la página
  const [randomPhrase] = useState(() => {
    return motivationalPhrases[Math.floor(Math.random() * motivationalPhrases.length)];
  });

  // Actualizar la hora cada segundo para mantenerla actualizada
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  return (
    <div className={`simply-page ${darkMode ? 'dark' : 'light'}`}>
      {/* Fecha y hora en esquina superior derecha */}
      <div className="time-display">
        <div className="time-date">
          {currentTime.toLocaleDateString('es-ES', { 
            weekday: 'long', 
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
        </div>
        <div className="time-hour">
          {currentTime.toLocaleTimeString('es-ES', { 
            hour: '2-digit', 
            minute: '2-digit',
            second: '2-digit'
          })}
        </div>
      </div>

      {/* Contenido principal */}
      {!showForm ? (
        <div className="main-content">
          <h1 className="main-title">Simply</h1>
          <p className="main-subtitle-secondary">{randomPhrase}</p>
          <div className="notice-banner">
            <p className="notice-text">
              Estamos mejorando nuestra infraestructura para ofrecerte una experiencia cada vez mejor. Durante este proceso, es posible que notes algunos procesos con algo de lentitud. Esperamos tenerlo solucionado cuanto antes y agradecemos tu comprensión.
            </p>
          </div>

          <div className="cta-section">
            <button className="support-button" onClick={toggleForm}>
              ¿Necesitas ayuda?
            </button>
          </div>
        </div>
      ) : (
        <div className="form-content">
          <div className="form-header">
            <h2 className="form-title">Formulario de Soporte</h2>
            <p className="form-subtitle">
              Completa el formulario con los detalles de tu consulta. Nuestro equipo te responderá lo antes posible.
            </p>
          </div>

          <div className="hubspot-form-container">
            <iframe 
              src="https://share-eu1.hsforms.com/1n-Wy2taSR8ml-XuJJrFlgAfbhti"
              width="100%"
              height="700"
              frameBorder="0"
              title="Formulario de Soporte Técnico"
              style={{ border: 'none', borderRadius: '12px' }}
            ></iframe>
          </div>

          <div className="back-section">
            <button className="back-button" onClick={toggleForm}>
              Volver
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SimplyPage;

